jQuery(document).ready(function ($) {
  // image alt
  $('img').each(function () {
    var img = $(this);
    var src = $(this).attr('src');
    var filename = src.split('/').reverse()[0].replace(/\.[^/.]+$/, '');
    if (img.parent('a').length != 0) {
      if (img.not('[alt]')) {
        img.attr('alt', 'image ' + filename);
      }
    } else {
      if (img.not('[alt]')) {
        img.attr('alt', '');
      }
    }
  });

  //Teams
  $('button.read-more').on('click', function (e) {
    e.preventDefault();
    $(this).parents('.member').toggleClass('open');
  });

  //Tables
  $('#main').responsiveTables();

  //Properties Gallery
  $('.property-detail-image-lists > img').on('click', function (e) {
    if (!($(this).is(':first-child'))) {
      $('.property-detail-image-lists').prepend($(this));
    }
  });

  if ($('.property-detail-document-lists').children('a').length === 0) {
    $('.property-detail-document-lists > h3').hide();
  }

});